module.exports = __webpack_public_path__ + "img/in.23aa28b1.png";